import type { Ref } from 'vue'
import type {
    RingBuilderResolveInput,
    RingBuilderResolveMode,
    RingSizeInput,
} from '@/graphql/api'
import { getCommissionJunctionInput } from '@/helpers/commission-junction'
import { getUri } from '@/helpers/getCurrentUri'
import { useCountryPlugin } from '@/plugins/country.ts'

import { useCurrencyInput } from '@/plugins/currency-input.ts'
import { logUnexpectedError } from '@/helpers'

export function useEngagementRingGetInput(
    centreStoneUri: Readonly<Ref<string | null>>,
    engraving: Readonly<Ref<string>>,
    handleRingSizeNotSelected: () => RingSizeInput | null
): {
    getInput: (mode: RingBuilderResolveMode) => RingBuilderResolveInput | null
} {
    const { countryCode } = useCountryPlugin()
    const currency = useCurrencyInput()
    const commissionJunction = getCommissionJunctionInput()

    const getInput = (
        mode: RingBuilderResolveMode
    ): RingBuilderResolveInput | null => {
        const uri = getUri()
        const ringSize = handleRingSizeNotSelected()

        if (!ringSize) {
            return null
        }

        if (!uri || !centreStoneUri.value) {
            logUnexpectedError('Could not get input', {
                uri,
                centreStoneUri: centreStoneUri.value,
            })

            return null
        }

        return {
            mode,
            centreStoneUri: centreStoneUri.value,
            commissionJunction,
            currency: currency.value,
            engraving: engraving.value,
            country: countryCode.value!,
            ringSize,
            uri,
        }
    }

    return {
        getInput,
    }
}
